import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@barges/react';
import classes from './classes.module.scss';
import withPGTranslation from '../../config/withPGTranslation';
import LoadingIndicator from '../../../common/helpers/loading_indicator';

function ReviewSection({
  advisorName,
  onSubmit,
  comment,
  t,
  loading
}) {
  const [text, setText] = useState('');

  useEffect(() => {
    setText(comment);
  }, [comment]);

  const onValueChanged = useCallback((e) => {
    setText(e.target.value);
  }, [comment]);

  return [
    <div className={ classes.divider } key="divider" />,
    <div className={ classes.reviewSectionContainer } key="main">
      <div className={ classes.flexDiv }>
        <div className={ classes.rateReviewSectionTitle }>{ t('rate_review.section_title') }</div>
      </div>
      <div className={ classes.flexDiv } style={ { marginBottom: 12 } }>
        <div className={ classes.advisorNameText }>{ advisorName }</div>
      </div>
      <div className={ classes.flexDiv } style={ { marginBottom: 12 } }>
        <textarea
          data-testid="review-textarea"
          value={ text }
          onChange={ onValueChanged }
          placeholder={ t('rate_review.section_placeholder') }
          className={ classes.inputArea }
          rows="7"
        />
      </div>
      {/* TODO: Remove this conditional rendering when @barges/react Button gets loading prop support.
          Replace with: <Button type="primary" title={t('rate_review.submit')} onClick={() => onSubmit(text || '')} loading={loading} />
      */}
      <div className={ classes.flexDiv } style={ { marginBottom: 12 } }>
        {loading ? (
          <div className={ classes.submitButtonLoading }>
            <LoadingIndicator />
          </div>
        ) : (
          <Button
            type="primary"
            title={ t('rate_review.submit') }
            onClick={ () => onSubmit(text || '') }
          />
        )}
      </div>
    </div>
  ];
}

export default withPGTranslation(ReviewSection);
